import { render } from "./SurveyProgressComponent.vue?vue&type=template&id=2b0e07ce"
import script from "./SurveyProgressComponent.vue?vue&type=script&lang=js"
export * from "./SurveyProgressComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__